import { render, staticRenderFns } from "./ChartStatusOrders.vue?vue&type=template&id=3de17879&scoped=true&"
import script from "./ChartStatusOrders.vue?vue&type=script&lang=js&"
export * from "./ChartStatusOrders.vue?vue&type=script&lang=js&"
import style0 from "./ChartStatusOrders.vue?vue&type=style&index=0&id=3de17879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de17879",
  null
  
)

export default component.exports